import { useEffect, useState } from "react";
import { getUserId, isMegatronCompanyUser, isMegatronFeatureOn, isMegatronLiteUser, isMegatronProUser } from "../Authentication/Auth";

const useMegatron = () => {
  const [isMegatronFeaturedOn, setIsMegatronFeaturedOn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchIsMegatronFeaturedOn = async () => {
    try {
      const megatronFeature = await isMegatronFeatureOn();
      setIsMegatronFeaturedOn(megatronFeature);
    } catch(error) {
      console.error('Error fetching megatron feature on');
      setIsMegatronFeaturedOn(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await fetchIsMegatronFeaturedOn();
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const megatronProUser = getUserId() != undefined && isMegatronProUser() && isMegatronFeatureOn;
  const megatronLiteUser = getUserId() != undefined && isMegatronLiteUser() && isMegatronFeatureOn;
  const megatronUser = getUserId() != undefined && isMegatronCompanyUser() && isMegatronFeatureOn;

  return {
    megatronLiteUser,
    megatronProUser,
    megatronUser,
    isMegatronFeaturedOn,
    isLoading
  }
}

export default useMegatron;